/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The distance between adjacent pixels in millimetres, equal to 25.4 divided by the PPI. Smaller dot pitch means a finer image.`)
};

const es_ppi_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La distancia entre píxeles adyacentes en milímetros, igual a 25,4 dividido entre el PPI. Un paso de píxel menor significa una imagen más fina.`)
};

const de_ppi_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Abstand zwischen benachbarten Pixeln in Millimetern, gleich 25,4 geteilt durch PPI. Ein kleinerer Pixelabstand bedeutet ein feineres Bild.`)
};

const nl_ppi_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De afstand tussen aangrenzende pixels in millimeters, gelijk aan 25,4 gedeeld door de PPI. Een kleinere dot pitch betekent een fijner beeld.`)
};

const fr_ppi_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La distance entre pixels adjacents en millimètres, égale à 25,4 divisé par le PPP. Un pas de masque plus petit signifie une image plus fine.`)
};

const it_ppi_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La distanza tra pixel adiacenti in millimetri, pari a 25,4 diviso il PPI. Un dot pitch più piccolo significa un'immagine più fine.`)
};

const pt_br2_ppi_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A distância entre pixels adjacentes em milímetros, igual a 25,4 dividido pelo PPI. Um dot pitch menor significa uma imagem mais fina.`)
};

const pt_ppi_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A distância entre pixels adjacentes em milímetros, igual a 25,4 a dividir pelo PPI. Um pitch de píxel menor significa uma imagem mais fina.`)
};

const ja_ppi_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隣接するピクセル間のミリメートル単位の距離で、25.4をPPIで割った値です。ドットピッチが小さいほど画像が精細になります。`)
};

const zh_ppi_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相邻像素之间以毫米为单位的距离，等于 25.4 除以 PPI。点距越小，图像越细腻。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_faq_a3", locale)
	if (locale === "en") return en_ppi_faq_a3(inputs)
	if (locale === "es") return es_ppi_faq_a3(inputs)
	if (locale === "de") return de_ppi_faq_a3(inputs)
	if (locale === "nl") return nl_ppi_faq_a3(inputs)
	if (locale === "fr") return fr_ppi_faq_a3(inputs)
	if (locale === "it") return it_ppi_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_faq_a3(inputs)
	if (locale === "pt") return pt_ppi_faq_a3(inputs)
	if (locale === "ja") return ja_ppi_faq_a3(inputs)
	return zh_ppi_faq_a3(inputs)
};